/**
 * Tool Search Module
 *
 * Exports all tool search related functionality for use throughout Meridian.
 */

export {
  DEFAULT_TOOL_SEARCH_CONFIG,
  REGEX_TOOL_SEARCH_CONFIG,
  TRADITIONAL_TOOL_CONFIG,
  getToolSearchConfig,
  validateToolSearchConfig,
  isHotTool,
  partitionToolIds,
  isToolSearchCapableModel,
  TOOL_SEARCH_CAPABLE_MODEL_TOKENS,
  type ToolSearchConfig,
  type ToolSearchVariant,
} from './tool-search-config.js';

export { recordToolSearchMetric, getToolSearchMetrics } from './metrics.js';

export type { ToolSearchMetrics } from './metrics.js';

export { logToolSearch, logToolDiscovery, logToolExecution } from './logging.js';
